/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateOrganizationRequest } from '../../models/create-organization-request';
import { OrganizationDto } from '../../models/organization-dto';

export interface OrganizationsPost$Plain$Params {
      body?: CreateOrganizationRequest
}

export function organizationsPost$Plain(http: HttpClient, rootUrl: string, params?: OrganizationsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationDto>> {
  const rb = new RequestBuilder(rootUrl, organizationsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrganizationDto>;
    })
  );
}

organizationsPost$Plain.PATH = '/organizations';
